'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../../providers/ClaimBuilder/index.js');
var SessionContext = require('../../providers/SessionContext.js');
var useAnalytics = require('../../providers/useAnalytics.js');
var useTitanAnalytics = require('../../providers/titan/useTitanAnalytics.js');
var ConfirmationProvider = require('./ConfirmationProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Confirmation = _ref => {
  let {
    children
  } = _ref;
  const {
    state: {
      claimType
    }
  } = index.useClaimBuilder();
  const {
    orderNumber
  } = SessionContext.useSession();
  const titan = useTitanAnalytics["default"]();
  const logEvent = useAnalytics["default"]();
  React.useEffect(() => {
    // Note: This effect is only called on first component render
    titan === null || titan === void 0 ? void 0 : titan.batch({
      batch: [{
        type: 'page',
        name: 'Confirmation'
      }]
    })
    // eslint-disable-next-line no-console
    .catch(e => console.error(e));
    logEvent({
      event_type: useAnalytics.ClaimsEventTypes.PAGE_LOAD,
      event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_CONFIRMATION,
      page_step: useAnalytics.ClaimsPageStep.CONFIRMATION,
      order_number: orderNumber,
      claim_reason: claimType
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, children);
};
const ConfirmationGuarded = _ref2 => {
  let {
    children
  } = _ref2;
  const {
    state: {
      claimEligibilityInfo
    },
    handleInvalidData
  } = index.useClaimBuilder();
  if (!claimEligibilityInfo) {
    handleInvalidData();
    return null;
  }
  return /*#__PURE__*/React__default["default"].createElement(ConfirmationProvider.ConfirmationProvider, {
    value: {
      claimEligibilityInfo
    }
  }, /*#__PURE__*/React__default["default"].createElement(Confirmation, null, children));
};

exports["default"] = ConfirmationGuarded;
